import React from 'react';
import styles from './style.module.css';

import workforIcon1 from '../../../assets/img/icon/workfor-icon1.svg';
import workforIcon2 from '../../../assets/img/icon/workfor-icon2.svg';
import workforIcon3 from '../../../assets/img/icon/workfor-icon3.svg';

export default function WorkForSection() {
  const workforContent = [
    {
      id: 1,
      icon: workforIcon1,
      title: 'Masyarakat',
      description:
        'Kami menghargai komunitas, ruang lingkup sosial dan kemajuan bersama.',
    },
    {
      id: 2,
      icon: workforIcon2,
      title: 'Lingkungan',
      description:
        'Pelestarian Alam, Lingkungan hidup adalah komitmen Perusahaan',
    },
    {
      id: 3,
      icon: workforIcon3,
      title: 'Kebijakan',
      description: 'Perusahaan berkerja dalam kebijakan yang adil dan jujur.',
    },
  ];

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>Bekerja Demi Kemajuan Bangsa</h2>
      <div className={styles.content}>
        {workforContent.map((item) => (
          <div key={`workfor-item-${item.id}`} className={styles.contentItem}>
            <img src={item.icon} alt={`icon ${item.title}`} />
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
